import acceptedCookiePolicy from "../components/onetrust/cookiePolicy";

const DRIFT_USER_COOKIE_NAME = 'cvo_drift_user';

const hideDrift = () => {
    if(typeof drift !== 'undefined'){
        drift.on('ready', () => { 
            drift.api.widget.hide();
         });
    } else {
        $(".drift").toggleClass("drift-shown");
    }
};

const showDrift = () => {
    if(typeof drift !== 'undefined'){
        drift.on('ready', () => { 
            drift.api.widget.show();
        });
    } else {
        showDriftFacade();
    }
};

const loadDrift = async () => {
    !function() {
        var t = window.driftt = window.drift = window.driftt || [];
        if (!t.init) {
            if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
            t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
            t.factory = function(e) {
                return function() {
                var n = Array.prototype.slice.call(arguments);
                return n.unshift(e), t.push(n), t;
                };
            }, t.methods.forEach(function(e) {
                t[e] = t.factory(e);
            }), t.load = function(t) {
                var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(o, i);
            };
        }
    }();

    if (typeof drift !== 'undefined') {
        let driftUserData = Cookies.get(DRIFT_USER_COOKIE_NAME);

        if (driftUserData) {
            driftUserData = JSON.parse(driftUserData);
        } else {
            const response = await http.get('/api/sitecore/drift/identify');

            if (response?.status === 200
                && 'data' in response
                && response.data.userId
                && response.data.userJwt) {
                driftUserData = {
                    userId: response.data.userId,
                    userJwt: response.data.userJwt
                };
            }

            acceptedCookiePolicy({
                ifFunctionalCookies: () => {
                    Cookies.set(DRIFT_USER_COOKIE_NAME, JSON.stringify(driftUserData));
                }
            });
        }

        drift.identify(driftUserData.userId, {}, { userJwt: driftUserData.userJwt });

        drift.SNIPPET_VERSION = '0.3.1';
        drift.load('acykb8t4sbft');

        drift.on('ready', () => {   
            $(".drift-widget, .drift-facade").addClass("drift-hidden");

            acceptedCookiePolicy({
                ifTargetingCookies: () => {
                    dataLayerBus.push({
                        'event': 'driftFacadeInteraction', 
                    });
                }
            });

            setTimeout( () => {
                drift.api.openChat();
            } , 1000);
        });
    }     
};

const checkIfExcludedUrl = () => {
    const excludedUrls = ["contact", "free-trial", "career", "gartner-magic-quadrant-for-ins", "ai-chatbot", "admin", "pdf", "platformdev", "platform.cloud", "ai-research", "research.coveo", "relevance-360/ecommerce"];
    const activeUrl = window.location.href;

    return excludedUrls.find(value => (activeUrl.includes(value)));
};


const showDriftFacade = () => {
    if( checkIfExcludedUrl() ===  undefined ) {
        acceptedCookiePolicy({
            ifTargetingCookies: () => {
               $(".drift").addClass("drift-shown");

               window.removeEventListener('scroll',showDriftFacade);
            }
        });
    }  
};

const hideDriftFacadeAndShowLoader = () => {
    $(".drift-facade").addClass("drift-dark-bg");
    $(".drift-icon-unread, .drift-facade-img").addClass("drift-hidden");
    $(".drift-loader").removeClass("hide-loader");
};

const hideLoader = () => {
    drift.on('ready', () => { 
        $(".drift-loader").addClass("hide-loader");
     });  
};

const closeDriftAvatar = () => {
    const facadeImg = $(".drift-facade-img");

    $(".drift-close-button").on('click', () => {
        $(".drift-widget, .drift-icon-unread").addClass("drift-hidden");
        facadeImg.attr("src", "/public/img/drift-icon.svg");
        facadeImg.addClass("drift-dark-bg");
        $('.drift').addClass("drift-avatar-closed");
    });
};

const initDriftOnClickFacade = () => {
    $(".drift-facade, .drift-widget-text").on('click', async () => {
        await loadDrift();
        hideDriftFacadeAndShowLoader();
        hideLoader();  
    }); 
};

const handleScrollShowDrift = () => {
    window.addEventListener('scroll', function() {
        if (  window.scrollY > 500 ) {
            showDriftFacade();
        }
    });
}

const initDrift = () => {
    handleScrollShowDrift();
    closeDriftAvatar();
    initDriftOnClickFacade();
};

export { hideDrift, showDrift, initDrift };